
import { mapState, mapMutations } from "vuex";
import InvalidFormatDialog from "../dialogs/menu-upload-info-dialog.vue";
import photoCropperDialog from "../dialogs/photo-cropper-dialog.vue";
import MenuUploadImageThumbnail from "./menu-upload-image-thumbnail.vue";

export default {
  components: {
    photoCropperDialog,
    InvalidFormatDialog,
    MenuUploadImageThumbnail
  },
  data() {
    return {
      bulkPhotos: [],
      allPhotos: [],
      selectedItems: [],
      items: [],
      MAX_IMAGE_SIZE_IN_BYTES: 2097152,
      showPhotoCropDialog: false,
      cropImg: null,
      selectedPhoto: "",
      selection: null,
      showUnsupportedFormatWarning: false
    };
  },
  computed: {
    ...mapState("menu", ["menuUploadList", "menuUploadImageList"]),
    filteredItems() {
      return (itemId) =>
        this.menuUploadList
          .filter(
            (menuItem) =>
              menuItem.id === itemId ||
              !this.menuUploadImageList.some(
                (img) => img.itemId === menuItem.id
              )
          )
          .map((menuItem) => ({
            item_name: menuItem.item_name,
            id: menuItem.id
          }));
    }
  },

  methods: {
    ...mapMutations("menu", [
      "DELETE_IMAGE_BY_INDEX",
      "ADD_IMAGES_TO_LIST",
      "UPDATE_IMAGE_UPLOAD_LIST_ITEM"
    ]),
    handleChangeItem(index, { id }) {
      this.UPDATE_IMAGE_UPLOAD_LIST_ITEM({ index, item: { itemId: id } });
    },
    openBulkUpload() {
      this.$refs.bulkUpload.$el.querySelector("input").click();
    },
    bulkPhotoChanged(val) {
      if (!val) return;
      const allowedFormats = ["image/png", "image/jpeg", "image/jpg"];

      const invalidFormatFiles = val.filter(
        (file) => !allowedFormats.includes(file.type)
      );
      const largeFiles = val.filter(
        (file) => file.size > this.MAX_IMAGE_SIZE_IN_BYTES
      );

      if (invalidFormatFiles.length > 0) {
        this.bulkPhotos = [];
        this.$refs.bulkUpload.reset();
        this.showUnsupportedFormatWarning = true;
        return;
      }

      if (largeFiles.length > 0) {
        this.bulkPhotos = [];
        this.$refs.bulkUpload.reset();
        this.showUnsupportedFormatWarning = true;
        return;
        // this.$nuxt.$emit(
        //   "show-error-toast",
        //   "One or more files are too large, max size is 2.6 MB."
        // );
      }
      const images = val.map((img) => {
        return { itemId: null, image: img };
      });
      this.ADD_IMAGES_TO_LIST(images);
      this.bulkPhotos = [];
    },
    editPhoto(index, photo) {
      this.currentEditIndex = index;
      this.selectedPhoto = photo.image;
      this.showPhotoCropDialog = true;
    },
    async onPhotoCropSave(croppedImage) {
      if (this.currentEditIndex !== null) {
        const item = { ...this.menuUploadImageList[this.currentEditIndex] };
        item.image = croppedImage;
        this.UPDATE_IMAGE_UPLOAD_LIST_ITEM({
          index: this.currentEditIndex,
          item
        });

        this.showPhotoCropDialog = false;
        this.currentEditIndex = null;
        this.selectedPhoto = null;
      }
    },
    deletePhoto(index) {
      this.DELETE_IMAGE_BY_INDEX(index);
    }
  }
};
